/**
 * @file use-shell-mode.ts
 * @description Режимы каркаса кабинета на время жизни страницы (phase19.16
 * Р1-6а, §7.16 фазы): меню кабинета шторкой на любой ширине и площадь
 * страницы без полей. Нужны конструктору сайта: ему нужна вся ширина окна,
 * а меню открывается кнопкой ≡. Верхняя панель, полоса входа под
 * сотрудником (SC24) и значок чата (SC64) остаются. Вне каркаса хуки ничего
 * не делают.
 */

import { useEffect } from "react";

import { useAppShellOptional } from "./AppShell";

/** Меню кабинета — шторкой, пока страница открыта. */
export function useDrawerMenu(on = true): void {
  const set = useAppShellOptional()?.setDrawerMenu;
  useEffect(() => {
    if (!set || !on) return;
    set(true);
    return () => set(false);
  }, [set, on]);
}

/** Контентная зона без полей и без предела ширины. */
export function useBleedLayout(on = true): void {
  const set = useAppShellOptional()?.setBleed;
  useEffect(() => {
    if (!set || !on) return;
    set(true);
    return () => set(false);
  }, [set, on]);
}
